import React from 'react';
import { SingleNumberCard } from '../../shared/components/numberInput/numberCards/singleNumberCard';
import { BoxStyled } from '../patientInformation/style';

export const MlView = ({
  setMlInput,
  value
}: {
  setMlInput: (val: number) => void;
  value: number;
}) => {
  return (
    <BoxStyled>
      <SingleNumberCard
        width={'50%'}
        title={'VOLUME'}
        marginVal={'0.625rem'}
        subHead={''}
        value={value}
        setValue={setMlInput}
      />
    </BoxStyled>
  );
};
